import React, { useState } from "react";
import styled from "styled-components";
import axios from "axios";

/* ─── Expanded car catalogue ─────────────────────────────────────────────
   Countries: USA, Japan, Germany, China, France, South Korea, India.
   Marques and models cover the common catalogue available in the Saudi
   market (new + used). Add/remove entries freely — the three Select
   dropdowns in the form drive themselves off this object. */
const carOptions = {
  USA: {
    Ford: [
      "F-150", "F-250", "F-350", "Ranger", "Mustang", "Escape", "Edge",
      "Explorer", "Expedition", "Bronco", "Bronco Sport", "Transit", "Fusion",
      "Focus", "Fiesta", "Taurus", "EcoSport", "Maverick",
    ],
    Chevrolet: [
      "Silverado", "Colorado", "Tahoe", "Suburban", "Equinox", "Traverse",
      "Trailblazer", "Blazer", "Malibu", "Impala", "Camaro", "Corvette",
      "Captiva", "Spark", "Cruze",
    ],
    Tesla: ["Model S", "Model 3", "Model X", "Model Y", "Cybertruck", "Roadster"],
    Dodge: [
      "Charger", "Challenger", "Durango", "Journey", "Ram 1500", "Ram 2500",
      "Ram 3500", "Hornet",
    ],
    Jeep: [
      "Wrangler", "Grand Cherokee", "Cherokee", "Compass", "Renegade",
      "Gladiator", "Grand Wagoneer", "Wagoneer",
    ],
    Cadillac: [
      "Escalade", "CT4", "CT5", "XT4", "XT5", "XT6", "Lyriq",
    ],
    GMC: ["Sierra", "Yukon", "Yukon XL", "Acadia", "Terrain", "Canyon", "Hummer EV"],
    Lincoln: ["Navigator", "Aviator", "Nautilus", "Corsair", "Continental", "MKZ"],
    Buick: ["Encore", "Enclave", "Envision", "Regal"],
    Chrysler: ["300", "Pacifica", "Voyager"],
  },

  Japan: {
    Toyota: [
      "Corolla", "Camry", "Avalon", "Prius", "Yaris", "C-HR", "RAV4",
      "Highlander", "Fortuner", "4Runner", "Land Cruiser", "Prado", "Rush",
      "Innova", "Hilux", "Hiace", "Tundra", "Tacoma", "Sequoia", "Sienna",
      "Raize", "Veloz", "GR86", "GR Supra", "Granvia",
    ],
    Nissan: [
      "Sunny", "Sentra", "Versa", "Altima", "Maxima", "Juke", "Kicks", "Rogue",
      "X-Trail", "Murano", "Pathfinder", "Patrol", "Armada", "Titan", "Navara",
      "Frontier", "370Z", "350Z", "GT-R", "Qashqai", "Micra",
    ],
    Honda: [
      "City", "Civic", "Accord", "Insight", "CR-V", "HR-V", "ZR-V", "Pilot",
      "Passport", "Ridgeline", "Odyssey", "Fit", "Jazz", "Amaze", "e:NS1",
    ],
    Mazda: [
      "Mazda 2", "Mazda 3", "Mazda 6", "CX-3", "CX-30", "CX-5", "CX-50",
      "CX-60", "CX-90", "MX-5", "BT-50",
    ],
    Mitsubishi: [
      "Lancer", "Attrage", "Mirage", "Space Star", "Xpander", "ASX",
      "Eclipse Cross", "Outlander", "Pajero", "Pajero Sport", "Montero Sport",
      "L200", "Triton",
    ],
    Subaru: [
      "Impreza", "Legacy", "Outback", "Forester", "Crosstrek", "WRX", "BRZ",
      "Ascent", "Solterra",
    ],
    Lexus: [
      "IS", "ES", "GS", "LS", "CT", "UX", "NX", "RX", "GX", "LX", "LC", "RC",
      "RZ", "LBX",
    ],
    Infiniti: ["Q50", "Q60", "Q70", "QX50", "QX55", "QX60", "QX70", "QX80"],
    Suzuki: [
      "Alto", "Swift", "Baleno", "Dzire", "Ciaz", "Vitara", "Grand Vitara",
      "Jimny", "S-Cross", "Ertiga", "XL6", "Celerio",
    ],
    Isuzu: ["D-Max", "MU-X", "Trooper", "Pickup"],
    Daihatsu: ["Terios", "Rocky", "Sirion", "Grand Move"],
  },

  Germany: {
    BMW: [
      "1 Series", "2 Series", "3 Series", "4 Series", "5 Series", "6 Series",
      "7 Series", "8 Series", "i3", "i4", "i7", "i8", "iX", "iX3", "X1", "X2",
      "X3", "X4", "X5", "X6", "X7", "Z4", "M2", "M3", "M4", "M5", "M8", "XM",
    ],
    "Mercedes-Benz": [
      "A-Class", "B-Class", "C-Class", "E-Class", "S-Class", "CLA", "CLS",
      "GLA", "GLB", "GLC", "GLE", "GLS", "G-Class", "AMG GT", "SL", "SLC",
      "EQA", "EQB", "EQC", "EQE", "EQS", "V-Class", "Vito", "Sprinter",
      "Maybach S-Class", "Maybach GLS",
    ],
    Audi: [
      "A1", "A3", "A4", "A5", "A6", "A7", "A8", "Q2", "Q3", "Q4 e-tron",
      "Q5", "Q7", "Q8", "e-tron", "e-tron GT", "R8", "TT", "RS3", "RS4",
      "RS5", "RS6", "RS7", "RS Q8", "S3", "S4", "S5", "S6", "S7", "S8",
    ],
    Volkswagen: [
      "Polo", "Golf", "Jetta", "Passat", "Arteon", "Tiguan", "Touareg",
      "T-Roc", "T-Cross", "Atlas", "Teramont", "ID.3", "ID.4", "ID.5",
      "ID.6", "ID.Buzz",
    ],
    Porsche: [
      "911", "718 Cayman", "718 Boxster", "Cayenne", "Macan", "Panamera",
      "Taycan",
    ],
    Opel: ["Astra", "Corsa", "Insignia", "Mokka", "Crossland", "Grandland"],
    Mini: ["Cooper", "Clubman", "Countryman", "Cooper Electric"],
    Smart: ["Fortwo", "Forfour", "Smart #1"],
  },

  China: {
    BYD: [
      "Qin", "Han", "Song", "Tang", "Yuan", "Dolphin", "Seal", "Atto 3",
      "Seagull", "Yangwang U8",
    ],
    Geely: [
      "Emgrand", "Coolray", "Azkarra", "Boyue", "Atlas", "Tugella", "Monjaro",
      "Preface", "Okavango",
    ],
    Chery: [
      "Tiggo 2", "Tiggo 3", "Tiggo 4", "Tiggo 7", "Tiggo 8", "Tiggo 9",
      "Arrizo 5", "Arrizo 6", "Omoda 5", "Omoda 7",
    ],
    Haval: ["H2", "H6", "H9", "F7", "F7x", "Jolion", "Dargo", "Big Dog"],
    "Great Wall": ["Wingle", "Poer", "Steed", "Ora Good Cat", "Tank 300", "Tank 500"],
    MG: [
      "MG3", "MG4", "MG5", "MG6", "MG7", "ZS", "HS", "RX5", "RX8",
      "Marvel R", "Cyberster", "GT",
    ],
    Changan: [
      "Alsvin", "Eado", "CS15", "CS35", "CS55", "CS75", "CS85", "CS95",
      "UNI-K", "UNI-T", "UNI-V",
    ],
    GAC: ["GS3", "GS4", "GS5", "GS8", "GA4", "GA6", "GA8", "Trumpchi M8"],
    Dongfeng: ["AX7", "Fengshen E70", "Rich 6", "Forthing T5"],
    NIO: ["ES6", "ES7", "ES8", "EC6", "EC7", "ET5", "ET7", "ET9"],
    Xpeng: ["P5", "P7", "G3", "G6", "G9", "X9"],
    "Li Auto": ["Li ONE", "Li L7", "Li L8", "Li L9", "Li MEGA"],
    Hongqi: ["H5", "H9", "HS5", "HS7", "E-HS9"],
    Jetour: ["X70", "X70 Plus", "X90", "Dashing", "T2"],
    Jaecoo: ["J7", "J8"],
    Lynk: ["01", "02", "03", "05", "06", "08", "09"],
  },

  UK: {
    "Land Rover": [
      "Defender", "Discovery", "Discovery Sport", "Range Rover",
      "Range Rover Sport", "Range Rover Velar", "Range Rover Evoque",
      "Freelander",
    ],
    Jaguar: [
      "XE", "XF", "XJ", "F-Type", "E-Pace", "F-Pace", "I-Pace",
    ],
    Mini: [
      "Cooper", "Cooper S", "Cooper SE", "Clubman", "Countryman",
      "Convertible", "John Cooper Works",
    ],
    Bentley: [
      "Continental GT", "Continental GTC", "Flying Spur", "Bentayga",
      "Mulsanne",
    ],
    "Rolls-Royce": [
      "Phantom", "Ghost", "Wraith", "Dawn", "Cullinan", "Spectre",
    ],
    "Aston Martin": [
      "DB11", "DB12", "Vantage", "DBX", "DBS", "Rapide", "Valkyrie",
    ],
    McLaren: [
      "540C", "570S", "600LT", "720S", "765LT", "Artura", "GT", "Senna",
      "P1",
    ],
    Lotus: [
      "Elise", "Exige", "Evora", "Emira", "Eletre", "Evija",
    ],
    Morgan: ["Plus Four", "Plus Six", "Super 3"],
    Vauxhall: ["Corsa", "Astra", "Insignia", "Mokka", "Grandland"],
  },

  Korea: {
    Hyundai: [
      "Accent", "Elantra", "Sonata", "Azera", "Verna", "Aura", "Grand i10",
      "i10", "i20", "i30", "Tucson", "Santa Fe", "Palisade", "Creta", "Venue",
      "Kona", "Veloster", "Staria", "H1", "H100", "Porter", "Ioniq", "Ioniq 5",
      "Ioniq 6",
    ],
    Kia: [
      "Picanto", "Rio", "Pegas", "Cerato", "K3", "K5", "Optima", "K7", "K8",
      "K9", "K900", "Sportage", "Sorento", "Telluride", "Carnival", "Carens",
      "Soul", "Stinger", "Seltos", "EV6", "EV9", "Niro",
    ],
    Genesis: ["G70", "G80", "G90", "GV60", "GV70", "GV80"],
    SsangYong: ["Rexton", "Tivoli", "Korando", "Actyon", "Rodius", "Musso"],
    Daewoo: ["Nubira", "Lanos", "Matiz", "Lacetti", "Winstorm"],
  },
};

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 600px;
  margin: 2rem auto;
  padding: 2rem;
  background-color: #f5f5f5;
  border-radius: 12px;
`;

const Label = styled.label`
  font-weight: bold;
`;

const Input = styled.input`
  padding: 0.7rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
`;

const Textarea = styled.textarea`
  padding: 0.7rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
`;

const Select = styled.select`
  padding: 0.7rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
`;

const Button = styled.button`
  padding: 0.8rem;
  background-color: #007bff;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background-color: #0056b3;
  }
`;

const Preview = styled.img`
  max-width: 180px;
  margin-top: 1rem;
  border-radius: 6px;
`;

const SmallPreview = styled.img`
  max-width: 120px;
  margin-top: 0.5rem;
  border-radius: 6px;
`;

const NewCar = ({ setUserCars }) => {
  const [car, setCar] = useState({
    country: "",
    marque: "",
    model: "",
    year: "",
    odometer: "",
    location: "",
    description: "",
    price: "",
  });

  const [mainImage, setMainImage] = useState(null);
  const [secondaryImages, setSecondaryImages] = useState([]);

  const token = localStorage.getItem("token");

  const handleSecondaryUpload = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const updated = [...secondaryImages];
    updated[index] = file;
    setSecondaryImages(updated);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Reset the dependent dropdowns when the parent choice changes so the
    // form never gets stuck with a stale "marque" or "model" after switching
    // country.
    if (name === "country") {
      setCar((prev) => ({ ...prev, country: value, marque: "", model: "" }));
    } else if (name === "marque") {
      setCar((prev) => ({ ...prev, marque: value, model: "" }));
    } else {
      setCar((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!mainImage) return alert("Please upload the main image");

    try {
      const formData = new FormData();

      Object.entries(car).forEach(([key, val]) => {
        formData.append(key, val);
      });

      // MAIN IMAGE
      formData.append("img", mainImage);

      // SECONDARY IMAGES
      secondaryImages.forEach((file, index) => {
        formData.append(`img${index + 1}`, file);
      });

      const res = await axios.post("/api/AffordableCars", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setUserCars((prev) => [...prev, res.data.car]);
      alert("Car added successfully!");

      // Reset form
      setCar({
        country: "",
        marque: "",
        model: "",
        year: "",
        odometer: "",
        location: "",
        description: "",
        price: "",
      });

      setMainImage(null);
      setSecondaryImages([]);
    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <h2>Add New Car Listing</h2>

      <Label>Country</Label>
      <Select
        name="country"
        value={car.country}
        onChange={handleChange}
        required
      >
        <option value="">Select Country</option>
        {Object.keys(carOptions).map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </Select>

      <Label>Marque</Label>
      <Select
        name="marque"
        value={car.marque}
        onChange={handleChange}
        required
      >
        <option value="">Select Marque</option>
        {car.country &&
          Object.keys(carOptions[car.country]).map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
      </Select>

      <Label>Model</Label>
      <Select name="model" value={car.model} onChange={handleChange} required>
        <option value="">Select Model</option>
        {car.country &&
          car.marque &&
          carOptions[car.country][car.marque].map((mod) => (
            <option key={mod} value={mod}>
              {mod}
            </option>
          ))}
      </Select>

      <Label>Year</Label>
      <Input
        name="year"
        type="number"
        value={car.year}
        onChange={handleChange}
        required
      />

      <Label>Odometer (km)</Label>
      <Input
        name="odometer"
        value={car.odometer}
        onChange={handleChange}
        required
      />

      <Label>Location</Label>
      <Input
        name="location"
        value={car.location}
        onChange={handleChange}
        required
      />

      <Label>Description</Label>
      <Textarea
        name="description"
        rows="3"
        value={car.description}
        onChange={handleChange}
        required
      />

      <Label>Price (SR)</Label>
      <Input
        name="price"
        type="number"
        value={car.price}
        onChange={handleChange}
        required
      />

      {/* MAIN IMAGE */}
      <Label>Main Image</Label>
      <Input
        type="file"
        onChange={(e) => setMainImage(e.target.files[0])}
        required
      />
      {mainImage && <Preview src={URL.createObjectURL(mainImage)} alt="main" />}

      {/* SECONDARY IMAGES — DYNAMIC */}
      {mainImage && (
        <>
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i}>
              {(i === 0 || secondaryImages[i - 1]) && (
                <>
                  <Label>Secondary Image {i + 1}</Label>
                  <Input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleSecondaryUpload(e, i)}
                  />
                  {secondaryImages[i] && (
                    <SmallPreview
                      src={URL.createObjectURL(secondaryImages[i])}
                    />
                  )}
                </>
              )}
            </div>
          ))}
        </>
      )}

      <Button type="submit">Submit Car</Button>
    </Form>
  );
};

export default NewCar;
